import { useEffect, createContext, useState, useContext } from 'react'
import router from 'utils/router'
import storage, { handleStorageError } from 'utils/storage'
import useStoryblok from 'utils/storyblok'
import { useStaticQuery, graphql } from 'gatsby'
import isClient from 'utils/isClient'

const formatOriginTheme = {
  1: 'itaucard',
  2: 'crediario',
  3: 'credicard',
  4: 'vitrine',
  5: 'recovery',
  6: 'iti',
  7: 'whatsapp',
  9: 'rede',
  10: 'reneg',
  11: 'pivo',
  12: 'hub',
}

let neededTheme = ''

const handleRoutes = (slug) => {
  const windowPathName =
    typeof window !== 'undefined' && window?.location?.pathname

  const originRoute = slug === 'recovery' ? '/' : `/${slug}`

  if (windowPathName) {
    const pathName = windowPathName?.replace('/', '')

    const newPathName = windowPathName === '/' ? '/' : `/${pathName}`

    if (newPathName === '/skipper') {
      neededTheme = 'itaucard'
    } else {
      neededTheme = originRoute[newPathName]
    }
  }
}

const handleSetColorVariables = (blok) => {
  Object.keys(blok || {}).forEach((keyProperty) => {
    const isInfoProps = [
      'header_logo',
      'component',
      '_editable',
      '_uid',
    ].includes(keyProperty)

    if (!isInfoProps) {
      const key = keyProperty?.replace(/_/g, '-')
      const property = `--${key}`
      const value = blok[keyProperty]?.color

      document.documentElement.style.setProperty(property, value)
    }
  })
}

const handleGetItauThemeFromUtmSource = (utmSource) => {
  const validSources = ['superapp-itau']

  if (validSources.includes(utmSource)) return 'itaucard'
}

export const ThemeContext = createContext({
  theme: 'recovery',
  setTheme: () => null,
})

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(
    () =>
      neededTheme ||
      router.getQueryString('theme') ||
      formatOriginTheme[router.getQueryString('origin')] ||
      handleGetItauThemeFromUtmSource(router.getQueryString('utm_source')) ||
      handleStorageError(storage.session.getItem('theme'), 'recovery') ||
      'recovery'
  )

  const {
    theme: { edges },
  } = useStaticQuery(graphql`
    {
      theme: allStoryblokEntry(filter: { field_component: { eq: "theme" } }) {
        edges {
          node {
            name
            full_slug
            content
            slug
          }
        }
      }
    }
  `)

  const handleSetTheme = (theme) => {
    setTheme(theme)
    storage.session.setItem('theme', theme)
  }

  handleRoutes(theme)

  let content = edges?.find(({ node }) => node?.slug === theme)?.node?.content
  content = content && JSON.parse(content)

  useStoryblok(content)

  useEffect(() => {
    if (content) {
      handleSetColorVariables(content)
    }
  }, [theme])

  const values = { theme, setTheme: handleSetTheme }

  return (
    <ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context && isClient()) {
    throw new Error(
      `useTheme hook must be used within a 'ThemeProvider' component`
    )
  }

  return context
}
